import React from "react";
import "./index.css";
import LazyImage from "../LazyImage";

const Intro = () => {
  return (
    <div className="section-styles-intro">
      <div className="column left-column">
        <div className="intro-text-wrapper-styles">
          <p className="intro-text-item-styles">
           Laura Terruso is an award-winning director, screenwriter, and producer who specializes in the field of comedy, embracing a heartfelt and character-driven approach. She has directed multiple films that have appeared in the Netflix Top 10 films globally.
          </p>
        </div>
      </div>
      <div className="column right-column">
        <div className="image-wrapper">
          <LazyImage
            alt="Laura Terruso Director Screenwriter Producer"
            className="scroll-image-4"
            src={require("./img/12.jpg")}
            width="1600"
            height="2400"
            isHero={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Intro;